module.exports = __webpack_public_path__ + "img/2.0ad79b43.jpg";